"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_WORKFLOW_PREFERENCES = exports.CHANNEL_PREFERENCE_DEFAULT = exports.WORKFLOW_PREFERENCE_DEFAULT = exports.PREFERENCE_DEFAULT_READ_ONLY = exports.PREFERENCE_DEFAULT_VALUE = void 0;
exports.PREFERENCE_DEFAULT_VALUE = true;
exports.PREFERENCE_DEFAULT_READ_ONLY = false;
exports.WORKFLOW_PREFERENCE_DEFAULT = {
    enabled: exports.PREFERENCE_DEFAULT_VALUE,
    readOnly: exports.PREFERENCE_DEFAULT_READ_ONLY,
};
exports.CHANNEL_PREFERENCE_DEFAULT = {
    enabled: exports.PREFERENCE_DEFAULT_VALUE,
};
exports.DEFAULT_WORKFLOW_PREFERENCES = {
    all: exports.WORKFLOW_PREFERENCE_DEFAULT,
    channels: {
        in_app: exports.CHANNEL_PREFERENCE_DEFAULT,
        sms: exports.CHANNEL_PREFERENCE_DEFAULT,
        email: exports.CHANNEL_PREFERENCE_DEFAULT,
        push: exports.CHANNEL_PREFERENCE_DEFAULT,
        chat: exports.CHANNEL_PREFERENCE_DEFAULT,
    },
};
